module.exports = __webpack_public_path__ + "img/Solomon Islands.8f7f61b6.svg";